import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rtmp-confirmation',
  templateUrl: './rtmp-confirmation.component.html',
  styleUrls: ['./rtmp-confirmation.component.css']
})
export class RtmpConfirmationComponent implements OnInit {
  public paymentReferenceNumber: string;

  constructor(private router: Router) {

  }

  ngOnInit(): void {
    // Get data from router state
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
    
    if (state && state.paymentReferenceNumber) {
      this.paymentReferenceNumber = state.paymentReferenceNumber;
    } else {
      // If no state found (direct URL access or refresh), redirect to main page
      this.router.navigate(['/quote-register']);
    }
  }

}